import { TRANSITION_DURATION_IN_MS } from '@constants';
import styled from '@emotion/styled';
import { IconButton } from '@lib/uikit';
import { FC, useState } from 'react';

import { useRatingContext } from '../../contexts/RatingContext';


const ANIMATION_COLOR = '#FFA3A5';
const ANIMATION_DURATION = TRANSITION_DURATION_IN_MS * 2;
const ANIMATION_SCALE = 1.1;

const AnimatedIconButton = styled(IconButton)<{ isAnimating: boolean }>`
    scale: ${({ isAnimating }) => (isAnimating ? ANIMATION_SCALE : 1)};
`;

export const LikeButton: FC = () => {
    const { isLiked, toggleLike } = useRatingContext();
    const [isAnimating, setIsAnimating] = useState(false);

    const handleClick = () => {
        setIsAnimating(true);
        setTimeout(() => {
            setIsAnimating(false);
        }, ANIMATION_DURATION);
        toggleLike();
    };

    return (
        <AnimatedIconButton
            ariaLabel='Like'
            isAnimating={isAnimating}
            icon={isLiked ? 'favorite' : 'favorite_border'}
            color={isAnimating ? ANIMATION_COLOR : undefined}
            onClick={handleClick}
        />
    );
};
